<script>
	import mapbox from 'mapbox-gl';
	export let geoJsonToFit;
	
	
	


	let map;
	let container;
	
	mapbox.accessToken = __myapp.env.API_KEY

	function load() {
		map = new mapbox.Map({
			container,
			style: 'mapbox://styles/mapbox/light-v11',
			center: [-6.26,53.349],
			zoom: 11,
			maxBounds: [[-12,50],[10,54]]
		});
		
		map.on("load", () => {
			map.addControl(new mapbox.NavigationControl({
        showCompass: false
      }))
      updateBounds()
      map.on("zoom", updateBounds);
      map.on("drag", updateBounds);
      map.on("move", updateBounds);
    });
	}
	
	 function updateBounds() {
    const bounds = map.getBounds()
    geoJsonToFit.features[0].geometry.coordinates = [bounds._ne.lng, bounds._ne.lat]
    geoJsonToFit.features[1].geometry.coordinates = [bounds._sw.lng, bounds._sw.lat]
  }

</script>

<svelte:head>
	<link
		rel="stylesheet"
		href="https://unpkg.com/mapbox-gl/dist/mapbox-gl.css"
		on:load={load}
	/>
</svelte:head>

<div bind:this={container}>
</div>

<style>
	div {
		width: 100%;
		height: 100%;
	}
</style>
